import React from 'react';
import { useSelector } from 'react-redux';
import { Grid, Header, Icon, List, Segment } from 'semantic-ui-react';
import LoadingComponent from '../../../app/layout/LoadingComponent';
//import { mainSkill } from '../applicationForm/SelectData/mainSkill';

export default function ApplicationDetailedCategories({
  languages,
  levels,
  media_type,
  skills,
}) {
  const { loading } = useSelector((state) => state.async);

  if (loading) return <LoadingComponent />;

  // const images = [
  //   '/assets/images/laptop-man-300.png',
  //   '/assets/images/laptop-woman-300.png',
  // ];

  // const randomNumber = Math.floor(Math.random() * 2);
  // const imageURL = images[randomNumber];

  return (
    <Grid>
      <Grid.Row stretched className='appCategories'>
        {/* <Grid.Column width={4}>
          <Image src={imageURL} />
        </Grid.Column> */}
        {(!skills || skills.length === 0) && (
          <Grid.Column computer={2}></Grid.Column>
        )}
        {languages && languages.length > 0 && (
          <Grid.Column computer={4} mobile={16}>
            <Segment clearing>
              <Header>
                <h3>
                  <Icon name='globe' /> Language(s)
                </h3>
              </Header>
              <List>
                {languages.sort().map((language) => (
                  <List.Item key={language}>{language}</List.Item>
                ))}
              </List>
            </Segment>
          </Grid.Column>
        )}
        {levels && levels.length > 0 && (
          <Grid.Column computer={4} mobile={16}>
            <Segment clearing>
              <Header>
                <h3>
                  <Icon name='list' /> Levels(s)
                </h3>
              </Header>
              <List>
                {levels.map((level) => (
                  <List.Item key={level}>{level}</List.Item>
                ))}
              </List>
            </Segment>
          </Grid.Column>
        )}
        {media_type && media_type.length > 0 && (
          <Grid.Column computer={4} mobile={16}>
            <Segment clearing>
              <Header>
                <h3>
                  <Icon name='computer' /> Media Type(s)
                </h3>
              </Header>
              <List>
                {media_type.map((media_type) => (
                  <List.Item key={media_type}>{media_type}</List.Item>
                ))}
              </List>
            </Segment>
          </Grid.Column>
        )}
        {skills && skills.length > 0 && (
          <Grid.Column computer={4} mobile={16}>
            <Segment clearing>
              <Header>
                <h3>
                  <Icon name='hand rock outline' /> Main Skills
                </h3>
              </Header>
              <List>
                {skills.map((skill) => (
                  <List.Item key={skill}>{skill}</List.Item>
                ))}
              </List>
            </Segment>
          </Grid.Column>
        )}
      </Grid.Row>
    </Grid>
  );
}
